import { blackColor, hexToRgb } from "assets/jss/style.js";

const cardStyle = {
  card: {
    border: "0",
   // marginBottom: "30px",
   // marginTop: "30px",
   // marginLeft: "5%",
   // marginRight: "5%",
    borderRadius: "6px", 
    color:  blackColor ,
    background: "rgba(255, 255, 255, 0.63)",
    width: "100%",
    boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem"
  },
  
  cardSimple: {
    border: "0",
    marginBottom: "0px",
    marginTop: "0px",
    marginLeft: "15px",
    marginRight: "15px",
    borderRadius: "6px", 
    color:  blackColor ,
    background: "rgba(255, 255, 255, 0.63)",
    width: "100%",
    boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem"
  },

  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardProfile: {
    marginTop: "30px",
    textAlign: "center"
  },
  cardChart: {
    "& p": {
      marginTop: "0px",
      paddingTop: "0px"
    }
  }
};

export default cardStyle;
